import { render, staticRenderFns } from "./RecursosProjecte.vue?vue&type=template&id=7d9ac248&scoped=true&"
import script from "./RecursosProjecte.vue?vue&type=script&lang=js&"
export * from "./RecursosProjecte.vue?vue&type=script&lang=js&"
import style0 from "./RecursosProjecte.vue?vue&type=style&index=0&id=7d9ac248&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9ac248",
  null
  
)

export default component.exports